export const currentDomain = () => {
  return process.env.DOMAIN
}
